import { apiFetch } from './client';
import type { NotificationsResponse } from '$lib/types';

export const notificationsApi = {
  list: (limit = 20) => apiFetch<NotificationsResponse>(`/notifications?limit=${limit}`),
  markRead: (ids?: number[]) =>
    apiFetch<null>('/notifications/read', {
      method: 'POST',
      body: JSON.stringify(ids ? { ids } : {})
    })
};
